import { routes } from "@constants/routes";
import {
  LanguageForm,
  LanguageTable,
  NativeLanguageForm,
  useResumeStore,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import {
  useGetLanguageCertificateByIdLazyQuery,
  useGetLanguagesCertificatesQuery,
  useGetNativeLanguagesQuery,
} from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

export type TLanguageState = "TABLE" | "FORM";

const LanguageTabContent = () => {
  const params = useParams();
  const location = useLocation();
  const { setLanguageEditId } = useResumeStore();
  const [languageState, setLanguageState] = useState<TLanguageState>("TABLE");
  const { data, refetch, loading } = useGetLanguagesCertificatesQuery({ variables: { id: params.id } });
  const { data: nativeLanguages, loading: loadingGetNativeLanguage } = useGetNativeLanguagesQuery({
    variables: { id: params.id },
  });
  const [getLanguageInfoById, { data: languageInfo, loading: getLanguageInfoLoading }] =
    useGetLanguageCertificateByIdLazyQuery();
  useEffect(() => {
    setLanguageEditId(undefined);
  }, [setLanguageEditId]);

  return (
    <div>
      {languageState === "TABLE" ? (
        <>
          <NativeLanguageForm
            data={{
              fluentLanguages: nativeLanguages?.admin?.jobSeekers?.edges[0]?.node?.profile?.fluentLanguages,
              nativeLanguage: nativeLanguages?.admin?.jobSeekers?.edges[0]?.node?.profile?.nativeLanguage,
            }}
            loading={loadingGetNativeLanguage}
            isDisabled={true}
          />
          <LanguageTable
            setLanguageState={setLanguageState}
            languageState={languageState}
            handleNextTab={() => {}}
            data={data?.admin?.jobSeekers?.edges[0]?.node?.languagecertificates || []}
            refetch={refetch}
            loading={loading}
            showAddNewSection={false}
          />
        </>
      ) : (
        <LanguageForm
          setLanguageState={setLanguageState}
          pathname={location.pathname}
          supportUrl={routes.support.main}
          getLanguageInfoById={getLanguageInfoById}
          languageInfo={languageInfo?.admin?.languageCertificate}
          getLanguageInfoLoading={getLanguageInfoLoading}
          userType={UserTypeEnum.ADMIN}
        />
      )}
    </div>
  );
};

export default LanguageTabContent;
